import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { AvailableIcons } from 'shared';

@Component({
  selector: 'tngh-alert',
  standalone: true,
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SvgIconComponent, NgClass],
})
export class AlertComponent {
  readonly title = input('');
  readonly icon = input<AvailableIcons>();
  readonly alertText = input('');
  readonly type = input<'info' | 'warning' | 'danger' | 'success'>('info');

  namePerType: { [key in string]: AvailableIcons } = {
    info: 'info-circle',
    warning: 'exclamation-triangle',
    danger: 'exclamation-sign',
    success: 'checkmark-circle',
  };
}
